import { useContext } from "react";
import { ModalContext } from "@/components/Modal";

export function useModal() {
  return useContext(ModalContext);
}
